import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResourceData } from '@app/shared/abstract/resource.data';
import { SupplierModel } from './supplier.model';

@Injectable({
  providedIn: 'root',
})
export class SupplierService extends AbstractEntityService<SupplierModel> {
  constructor(http: HttpClient) {
    super('/api/suppliers', http);
  }

  saveFormData(formData: FormData, supplierId?: number | null): Observable<ResourceData<SupplierModel>> {
    if (supplierId) {
      return this.http.post<ResourceData<SupplierModel>>(`${this.apiUrl}${this.basePath}/${supplierId}`, formData);
    } else {
      return this.http.post<ResourceData<SupplierModel>>(`${this.apiUrl}${this.basePath}`, formData);
    }
  }
}
